var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Accordion',{ref:"el",staticClass:"Qa",attrs:{"id":_vm.id,"markdown":_vm.answer,"title":`${_vm.number}. ${_vm.question}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }